<template>
    <div id="background-container-3d">
         <Scene v-model="scene" id="scene-1" :class="sceneStat">
            <property name="clearColor" color="#0000" @complete="assign"/>
            <Camera v-model="camera" type="follow" :position="cameraPosition"/>
            <Entity v-model="earthEntity" :position="earthPosition" :rotation="earthRotation" :antialias="false" :alpha="false">
                <Asset src="/img/3dAssets/earth/Earth.babylon">
                    <property name="clearColor" color="#0000"></property>
                    <Material>
                        <property name="clearColor" color="#0000"></property>
                        <Texture
                                v-model="earthTexture"
                                src="/img/3dAssets/earth/PlanetEarth_DIFFUSE.jpg"
                        >
                            <property name="clearColor" color="#0000"></property>
                        </Texture>
                    </Material>
                </Asset>
            </Entity>
        </Scene>    
    </div>
</template>

<script>

    import Vue from "vue";
    import vb from "vue-babylonjs";
    import ChartIndicator from "./ChartIndicator";
    import EventBus from "../main";

    Vue.use(vb);

    export default {
        name: "BackgroundContainer3D",
        components: {ChartIndicator},
        data() {
            return {
                scene: null,
                sceneStat: '',
                storyTime: false,
                earthTexture: null,
                earthPosition: [0, 0.6, -7.5],
                earthRotation: [0, 0, 0],
                earthEntity: null,
                stage: Object,
                camera: null,
                cameraPosition: [0, 2.1, -9.68],
                lightPosition: {x: 4000, y: 0, z: 4030},
                light: Object,
                rotationLoop: null,
                lightPositionStory: null,
                lightPositionDefault: null,
                rotationAnimation: new vb.BABYLON.Animation("rotationY", "rotation.y", 30, vb.BABYLON.Animation.ANIMATIONTYPE_FLOAT, vb.BABYLON.Animation.ANIMATIONLOOPMODE_RELATIVE),
                positionAnimation: new vb.BABYLON.Animation("positionEarth", "position", 30, vb.BABYLON.Animation.ANIMATIONTYPE_VECTOR3, vb.BABYLON.Animation.ANIMATIONLOOPMODE_RELATIVE),
                lightAnimationStory: new vb.BABYLON.Animation("positionLightStory", "position", 30, vb.BABYLON.Animation.ANIMATIONTYPE_VECTOR3, vb.BABYLON.Animation.ANIMATIONLOOPMODE_RELATIVE),
                lightAnimationDefault: new vb.BABYLON.Animation("positionLightDefault", "position", 30, vb.BABYLON.Animation.ANIMATIONTYPE_VECTOR3, vb.BABYLON.Animation.ANIMATIONLOOPMODE_RELATIVE)
            };
        },
        computed: {
            pageStatus() {
                return this.$store.state.navigationStatus;
            }
        },
        watch: {
            pageStatus(value) {
                switch (value) {
                    case 'home':
                    case 'subPage':
                        this.canvasFade('show');
                        break;
                    case 'story':
                        this.canvasFade('fadeOut');
                        break;
                }
            }
        },
        methods: {
            assign(scene) {
                this.stage = scene.scene;
                this.light = new vb.BABYLON.HemisphericLight("HemiLight", new vb.BABYLON.Vector3(this.lightPosition.x, this.lightPosition.y, this.lightPosition.z), this.stage);
                this.light.intensity = 2000;
                this.camera.rotation.x = 0.95;
                this.assignAnimations();
            },
            assignAnimations() {
                let rotationKeys = [];
                rotationKeys.push({frame: 0, value: 0});
                rotationKeys.push({frame: 100, value: -1 * (Math.PI * 2)});

                this.rotationAnimation.setKeys(rotationKeys);
                this.earthEntity.animations.push(this.rotationAnimation);
                this.rotationLoop = this.stage.beginAnimation(this.earthEntity, 0, 100, true, 0.20);

                /* Light positions */

                /*                let lightPositionKeysStory = [];
                                lightPositionKeysStory.push({frame: 0, value: new vb.BABYLON.Vector3(4000, 0, 4030)});
                                lightPositionKeysStory.push({frame: 100, value: new vb.BABYLON.Vector3(4000, -4000, -4030)});

                                this.lightAnimationStory.setKeys(lightPositionKeysStory);
                                this.light.animations.push(this.lightAnimationStory);
                                this.lightPositionStory = this.stage.beginAnimation(this.light, 0, 100, false, 0.20);

                                let lightPositionKeysDefault = [];
                                lightPositionKeysDefault.push({frame: 0, value: new vb.BABYLON.Vector3(4000, 4000, 4030)});
                                lightPositionKeysDefault.push({frame: 100, value: new vb.BABYLON.Vector3(4000, 0, 4030)});

                                this.lightAnimationDefault.setKeys(lightPositionKeysDefault);
                                this.light.animations.push(this.lightAnimationDefault);
                                this.lightPositionDefault = this.stage.beginAnimation(this.light, 0, 100, false, 0.20);*/

            },
            startRotate() {
                this.rotationLoop.restart();
            },
            stopRotate() {
                this.rotationLoop.pause();
            },
            lightPositionTo(type) {
                switch (type) {
                    case 'story':
                        this.lightPositionStory.restart();
                        break;
                    case 'default':
                        this.lightPositionDefault.restart();
                        break;
                }
            },
            toStoryPosition() {
                // earthPosition: [0, -0.6, -9.5],
                // lightPosition: {x : 4000, y: -4000, z: -4030},
            },
            canvasFade(type) {
                type === 'fadeOut' ? this.sceneStat = '' : this.sceneStat = 'show';
            }
        },
        mounted() {
            EventBus.$on('story-background', (data) => {
                data === 'home' && this.canvasFade('show');
            });
        }
    };
</script>

<style lang="scss">
    #background-container-3d {
        position: absolute;
        top: 0;
        z-index: 1;
        width: 100%;
        height: 100vh;
        max-width: 1900px;
        max-height: 1080px;

        #scene-1 {
            width: 100%;
            height: 100%;
            opacity: 0;
            transition: opacity 800ms ease-in-out;
            max-width: 1900px;
            max-height: 1080px;

            &.show {
                opacity: 1;
            }
        }

        canvas {
            max-height: 100vh;
        }
    }
</style>
